/**
 * FloatingOrbs - Pure CSS animated orbs for performance
 * Replaces Framer Motion with CSS animations to reduce JS bundle and improve mobile performance
 */
const FloatingOrbs = () => {
  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none floating-orbs-container">
      {/* Primary orb */}
      <div
        className="floating-orb floating-orb-primary"
        aria-hidden="true"
      />
      
      {/* Secondary orb */}
      <div
        className="floating-orb floating-orb-secondary"
        aria-hidden="true"
      />

      {/* Accent orb */}
      <div
        className="floating-orb floating-orb-accent"
        aria-hidden="true"
      />
    </div>
  );
};

export default FloatingOrbs;
